/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DermOnCall Patient API
 * OpenAPI spec version: 1.0
 */
import { useMutation } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';

import type {
  SsoLoginErrorResponse,
  SsoLoginRequest,
  SsoLoginSuccessResponse,
} from './api.schemas';

import { api } from '../util/http';

export const ssoLogin = (ssoLoginRequest: SsoLoginRequest, signal?: AbortSignal) => {
  return api<SsoLoginSuccessResponse>({
    url: `/api/auth/sso-login`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: ssoLoginRequest,
    signal,
  });
};

export const getSsoLoginMutationOptions = <
  TError = SsoLoginErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof ssoLogin>>,
    TError,
    { data: SsoLoginRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof ssoLogin>>,
  TError,
  { data: SsoLoginRequest },
  TContext
> => {
  const mutationKey = ['ssoLogin'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof ssoLogin>>,
    { data: SsoLoginRequest }
  > = (props) => {
    const { data } = props ?? {};

    return ssoLogin(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SsoLoginMutationResult = NonNullable<Awaited<ReturnType<typeof ssoLogin>>>;
export type SsoLoginMutationBody = SsoLoginRequest;
export type SsoLoginMutationError = SsoLoginErrorResponse;

export const useSsoLogin = <TError = SsoLoginErrorResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof ssoLogin>>,
      TError,
      { data: SsoLoginRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof ssoLogin>>,
  TError,
  { data: SsoLoginRequest },
  TContext
> => {
  const mutationOptions = getSsoLoginMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
